module.exports = __webpack_public_path__ + "static/media/physiotherapie-mobile.7b6fd855.jpg";